import {
  unidades,
  categoriasClientes,
  listaClientesCadastrados,
  listaCupons,
  buscaProduto,
  buscaCliente,
  buscaCategoriaProduto,
  buscaUnidade,
} from '@/services/kpis.js'
import { getUsers } from '@/services/auth.js'
import { setData, removeData } from '@/services/storage.js'
import usuariosServices from '@/modules/usuarios/services'
import { DateTime } from 'luxon'
import * as lastUpdateService from '@/services/lastUpdate'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import { apolloProvider } from '@/apollo-provider.js'
import { QUERY_ACCOUNT_FRANCHISEE_PERMISSIONS } from '@/modules/configuracoes/permissionamento-filiado/graphql'
import gql from 'graphql-tag'

export default {
  async getLojas({ commit, dispatch, state }) {
    try {
      let { data } = await unidades()
      if (!Array.isArray(data)) data = [data]
      commit('SET_OBJECT', { name: 'unidades', data, state })
      return data
    } catch (error) {
      throw error
    }
  },
  setEnqueuedCashbackAdjustmentReportState({ commit }, payload) {
    commit('SET_ENQUEUED_CASHBACK_ADJUSTMENT_REPORT_STATE', payload)
  },
  setFilters({ state, commit }, data) {
    commit('SET_OBJECT', { name: 'filters', data, state })
  },
  async categoriasClientes({ state, dispatch, commit }) {
    let { data } = await categoriasClientes()
    if (!Array.isArray(data)) data = [data]
    commit('SET_OBJECT', { name: 'categoriasClientes', data, state })
  },
  async listaClientesCadastrados({ state, dispatch, commit }, filter) {
    const { data } = await listaClientesCadastrados(filter)
    return data
  },
  async listaCupons({ state, dispatch, commit }, filter) {
    const { data } = await listaCupons(filter)
    return data
  },
  async getUsuarios({ state, dispatch, commit }) {
    const { data } = await getUsers()
    return data
  },
  async buscaProdutos({ dispatch }, filter) {
    const data = await buscaProduto(filter)
    return data
  },
  async buscaClientes({ dispatch }, filter) {
    const data = await buscaCliente(filter)
    return data
  },
  async buscaCategoriaProdutos({ dispatch }, filter) {
    const data = await buscaCategoriaProduto(filter)
    return data
  },
  async buscaLojas({ dispatch }, filter) {
    const data = await buscaUnidade(filter)
    return data
  },
  setExpectedRecoveryDate({ state, commit }, date) {
    date = DateTime.fromFormat(date.toString(), 'YYYY-MM-DD HH:mm:SS').toFormat('DD/MM/YYYY HH:mm:SS')
    commit('SET_OBJECT', { name: 'expectedRecoveryDate', data: date, state })
  },
  async getStates({ dispatch }, dateArray) {
    const promises = dateArray.map((item) => {
      return dispatch(item, false)
    })

    await Promise.all(promises)
  },
  async getLastUpdate({ state, commit }) {
    if (!isEmpty(state.lastUpdate)) return

    // If already fetching, wait for the existing promise
    if (state._getLastUpdatePromise) {
      return state._getLastUpdatePromise
    }

    // Create and store the promise to prevent concurrent calls
    const promise = (async () => {
      try {
        const data = await lastUpdateService.getLastUpdated()

        if (data.processing_uuid) window.localStorage.setItem('processing_uuid', data.processing_uuid)

        commit('SET_OBJECT', { name: 'lastUpdate', data, state })
        return data
      } finally {
        // Clear the promise reference when done
        commit('SET_OBJECT', { name: '_getLastUpdatePromise', data: null, state })
      }
    })()

    // Store the promise to prevent concurrent calls
    commit('SET_OBJECT', { name: '_getLastUpdatePromise', data: promise, state })

    return promise
  },
  async ensureLastUpdate({ dispatch, state }) {
    // If lastUpdate is already populated, no need to wait
    if (!isEmpty(state.lastUpdate)) {
      return state.lastUpdate
    }

    // Dispatch getLastUpdate and wait for it to complete
    return dispatch('getLastUpdate')
  },
  async getUserPermissions({ state, commit }, id) {
    if (!state.userPermissions.length) {
      try {
        const data = await usuariosServices.getUserById(id)
        commit('SET_OBJECT', { name: 'userPermissions', data: data.pages, state })
      } catch (e) {
        commit('SET_OBJECT', { name: 'userPermissions', data: [], state })
      }
    } else {
      return state.userPermissions
    }
  },
  setUserPermissions({ state, commit }, permissions) {
    commit('SET_OBJECT', { name: 'userPermissions', data: permissions, state })
  },
  setQuickAction({ state, commit }, action) {
    const key = 'quickAction'
    setData(key, action)
    commit('SET_OBJECT', { name: key, data: action, state })
  },
  unsetQuickAction({ state, commit }) {
    const key = 'quickAction'
    removeData(key)
    commit('SET_OBJECT', { name: key, data: {}, state })
  },
  setPreFilters({ state, commit }, filters) {
    const key = 'preFilters'
    setData(key, filters)
    commit('SET_OBJECT', { name: key, data: filters, state })
  },
  unsetPreFilters({ state, commit }) {
    const key = 'preFilters'
    removeData(key)
    commit('SET_OBJECT', { name: key, data: {}, state })
  },
  includeQuickActionGroup({ state, commit }, quickActionGroup) {
    let quickActionGroups = cloneDeep(state.quickActionGroups)

    quickActionGroups.push(quickActionGroup)

    commit('SET_OBJECT', { name: 'quickActionGroups', data: quickActionGroups, state })
    commit('SET_OBJECT', { name: 'isSelectingQuickActionGroups', data: true, state })
  },
  removeQuickActionGroup({ state, commit }, quickActionGroupId) {
    let quickActionGroups = cloneDeep(state.quickActionGroups).filter((group) => group.id !== quickActionGroupId)

    commit('SET_OBJECT', { name: 'quickActionGroups', data: quickActionGroups, state })
    commit('SET_OBJECT', { name: 'isSelectingQuickActionGroups', data: true, state })
  },
  setIsIncludingSegments({ state, commit }, isIncludingSegments) {
    if (!isIncludingSegments) {
      commit('SET_OBJECT', { name: 'quickActionGroups', data: [], state })
    }
    commit('SET_OBJECT', { name: 'isSelectingQuickActionGroups', data: isIncludingSegments, state })
  },
  setDateFilterSelectedPeriod({ state, commit }, selectedPeriod) {
    commit('SET_OBJECT', { name: 'dateFilterSelectedPeriod', data: selectedPeriod, state })
  },
  async getFranchiseePermissions({ dispatch, state }) {
    let stateFranchiseePermissions = state.franchiseePermissions
    try {
      const { data } = await apolloProvider.defaultClient.query({
        query: QUERY_ACCOUNT_FRANCHISEE_PERMISSIONS,
        fetchPolicy: 'no-cache',
      })
      stateFranchiseePermissions = Object.assign(stateFranchiseePermissions, data.accountFranchiseePermissions)
      dispatch('setFranchiseePermissions', stateFranchiseePermissions)
    } catch (error) {
      console.error(error)
    }
  },
  setFranchiseePermissions({ state, commit }, permissions) {
    const key = 'franchiseePermissions'
    const isEncrypted = true
    setData(key, permissions, isEncrypted)
    commit('SET_OBJECT', { name: 'franchiseePermissions', data: permissions, state })
  },
  trackRouteAccess({ state }, { route, genericRoute }) {
    // Fire tracking mutation without awaiting
    apolloProvider.defaultClient
      .mutate({
        mutation: gql`
          mutation TrackPlatformUser($route: String!, $genericRoute: String!) {
            trackPlatformUser(route: $route, genericRoute: $genericRoute)
          }
        `,
        variables: {
          route,
          genericRoute,
        },
      })
      .catch((error) => {
        // Silently handle errors since we don't want to block navigation
        console.warn('[TRACKING] Failed to track route access:', error)
      })
  },
}
